<div [class]="envClass" class="popup-container">
  <!-- TOOLBAR HEADER -->
  <mat-toolbar class="custom-toolbar">
    <span class="toolbar-title">{{ isEdit ? 'Edit List' : 'New List' }}</span>
    <span class="fill-empty-space"></span>
    <div class="toolbar-actions">
      <button mat-icon-button (click)="save()" matTooltip="Save list" [disabled]="!list.description">
        <mat-icon>save</mat-icon>
      </button>
      <button mat-icon-button (click)="close()" matTooltip="Cancel">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </mat-toolbar>

  <!-- FORM CONTENT WRAPPER -->
  <div class="content-wrapper">
    <!-- List Name Field -->
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Name</mat-label>
      <input 
        matInput 
        name="description" 
        required 
        [(ngModel)]="list.description" 
        placeholder="Enter list name..." 
        (keyup.enter)="save()"
        autofocus
      >
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Calendar</mat-label>
      <mat-select [(ngModel)]="calendar" [compareWith]="functions.objectComparisonFunction"
      (selectionChange)="changeCalendar(calendar)">
        <mat-option [value]="null">-- None (Standalone List) --</mat-option>
        <mat-option *ngFor="let cal of calendars" [value]="cal">
          {{ cal.summary }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <div class="sharing-section">
      <span class="section-title">Shared With</span>

      <!-- Input om e-mailadres toe te voegen -->
      <div class="add-email-row">
        <mat-form-field appearance="outline" class="full-width email-input">
          <mat-label>Add user email</mat-label>
          <input 
            matInput 
            type="email" 
            [(ngModel)]="newSharedEmail" 
            placeholder="user@example.com"
            (keyup.enter)="addSharedUser()"
          >
        </mat-form-field>
        <button 
          mat-icon-button 
          type="button" 
          class="btn-add-email" 
          (click)="addSharedUser()" 
          matTooltip="Add email"
          [disabled]="!newSharedEmail || !newSharedEmail.trim()"
        >
          <mat-icon>add</mat-icon>
        </button>
      </div>

      <!-- Lijst met al toegevoegde e-mailadressen -->
      <div class="shared-users-list" *ngIf="sharedListMembers && sharedListMembers.length > 0">
        <div class="shared-user-item" *ngFor="let sharedListMember of sharedListMembers; let i = index">
          
          <div class="user-info">
            <mat-icon class="user-icon">person_outline</mat-icon>
            <span class="user-email">{{ sharedListMember.emailAddress || 'No email specified' }}</span>
          </div>

          <button 
            mat-icon-button 
            type="button" 
            class="btn-remove-user" 
            (click)="removeSharedUser(i)" 
            matTooltip="Remove"
          >
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </div>

      <!-- Geen e-mailadressen gecategoriseerd -->
      <div class="no-shared-users" *ngIf="!sharedListMembers || sharedListMembers.length === 0">
        <span>Not shared with anyone yet.</span>
      </div>
    </div>
  </div>
</div>